import React , { useState } from 'react';
import {
  ListGroup,
  ListGroupItem,
  Card,
  CardBody,
  CardHeader,
  Button,
} from "reactstrap";
import Dropzone from "react-dropzone";
import { useSelector } from 'react-redux';
import { uniqueId } from 'lodash';
import { useDispatch } from 'react-redux';
import { close_confirm_modal, open_confirm_modal } from '../../../slices/Confirm_Modal/reducer';
import { waitForDecision } from '../../../utility/wait_for_confirmation';
import { update_Bot_Combine } from '../../../slices/thunks';
import { update_old_file_list } from '../../../slices/BotDetails/reduders';
import Loader from '../../../Components/Common/Loader';
import { open_error_modal } from '../../../slices/Error_Modal/reducer';
import config from '../../../config';


const File_Upload = () => {
 

  // Get the File Details . 
  const BotDetails = useSelector((state) => state.BotDetails.Bot_Details);
 const  create_new_bot_details =  useSelector((state) => state.Create_Bot)
  const [files, setfiles] = useState([])
  const dispatch = useDispatch()


  const onclick_delete_Currently_Uploaded = async ( file_id )=>{
    
    dispatch(open_confirm_modal("Are you sure you want to delete this file?"))

    const decision = await waitForDecision()

    if ( decision){
      const temp_files = files.filter((file_element)=> file_element[1] !== file_id)

      setfiles(temp_files)
      dispatch(close_confirm_modal())
  
    }else{
      dispatch(close_confirm_modal())
    }
    

    
  }


  const onclick_delete_old_file = async ( file_id )=>{
    
    dispatch(open_confirm_modal("Are you sure you want to delete this file?"))

    const decision = await waitForDecision()

    if (decision){
      // console.log(BotDetails.Files_Path.split(','))
      let temp_files = BotDetails.Files_Path.split(',').filter((file_element)=> file_element !== file_id)
      temp_files = temp_files.join(',')
     
      dispatch(update_old_file_list(temp_files))
      dispatch(close_confirm_modal())
    }else{
      dispatch(close_confirm_modal())
    }
    

    
  }


 const onClick_Upload_File=()=>{
       // Prepare file with form data 
       let data = new FormData();
       files.forEach((ele)=>{
          data.append('file',ele[0])
       })


       data.append('Bot_ID',BotDetails.Bot_ID)
       data.append('API_TYPE','File')


         data.append('OLD_FILENAME',BotDetails.Files_Path? BotDetails.Files_Path:'')
  
       
       
       dispatch(update_Bot_Combine(data))

       setfiles([])
  }



  return (
    <>
      <div className="file_content_wrap">
        <Card>
          <CardHeader>
            {!(create_new_bot_details.loading || BotDetails.loading )  && <div className="cust_header">File <Button  color="secondary" onClick={onClick_Upload_File} >Save</Button></div>
}
            </CardHeader>
          {(create_new_bot_details.loading || BotDetails.loading )? <Loader/>:<CardBody>
            
            <Dropzone
               multiple={true}
              accept={{
                "application/pdf": [".pdf"],
                "application/vnd.openxmlformats-officedocument.wordprocessingml.document":
                  [".docx"],
                "application/msword": [".doc"],
                "text/plain": [".txt"],
                "application/vnd.ms-excel": [".xls"],
                "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": [".xlsx"],
                "text/csv": [".csv"],
                "application/vnd.openxmlformats-officedocument.presentationml.presentation": [".pptx"],
                "application/vnd.ms-powerpoint": [".ppt"]
              }}
              onDrop={(acceptedFiles) => {
                // console.log(`Accepted files: ${acceptedFiles}`);
                // Combine new files with existing ones
                setfiles([...files, ...acceptedFiles.map(file => [file, uniqueId()])]);
              }}
              onDropRejected={(rejectedFiles) => {
                rejectedFiles.forEach(file => {
                  dispatch(open_error_modal(`File ${file.file.name} is not accepted. Please upload a valid file.`))
                  // alert(`File ${file.file.name} is not accepted. Please upload a valid file.`);
                  setfiles([...files])
                });
              }}
            >
              {({ getRootProps, getInputProps }) => (
                <div className="dropzone dz-clickable">
                  <div className="dz-message needsclick" {...getRootProps()}>
                  <input {...getInputProps()} />
                    <div className="mb-3">
                      <i className="display-4 text-muted ri-upload-cloud-2-fill" />
                    </div>
                    <h4>Drag & drop files here, or click to select files</h4>
                    <p>
                      <small>
                        Supported File Types: .pdf, .doc, .docx, .txt, .ppt , .pptx , .xlsx
                      </small>
                    </p>
                  </div>

                </div>
              )}
            </Dropzone>

            <div className="list_wrapper">
              <p className="mt-10">
                If you are uploading a pdf, make sure you can select / highlight
                the text.
              </p>
              <ListGroup>
              { BotDetails.Files_Path &&  BotDetails.Files_Path.split(',').map((ele, i) => {
                  return (
                    <ListGroupItem className="d-flex justify-content-between align-items-center">
                      <a className='filename' href={`${config.api.API_URL}/${ele}`} target='_blank'>{ele.split('/').at(-1)}</a>
                      <span
                        onClick={() => {
                          onclick_delete_old_file(ele);
                        }}
                        className="badge red"
                      >
                        <i className="ri-delete-bin-6-line"></i>
                      </span>
                    </ListGroupItem>
                  );
                })}
                {files.map((ele, i) => {
                  return (
                    <ListGroupItem className="d-flex justify-content-between align-items-center">
                      {ele[0].name}
                      <span
                        onClick={() => {
                          onclick_delete_Currently_Uploaded(ele[1]);
                        }}
                        className="badge red"
                      >
                        <i className="ri-delete-bin-6-line"></i>
                      </span>
                    </ListGroupItem>
                  );
                })}
              </ListGroup>
            </div>
          </CardBody>}
        </Card>
      </div>
    </>
  );
}

export default File_Upload
